import { FHIR_API_ENDPOINT, FHIR_API_ENDPOINT_PERSON, FHIRHEADERS } from './Constants.js';
import { toast } from 'react-toastify';

export default class MiEFhir {
  userType = "TRD"; // AH-auction house, TRD- trader

  constructor() {
    this.currentUser();
  }

  async login(user) {
    console.log("HyperUsers Login to API users.js");
    try {
      const response = await fetch(FHIR_API_ENDPOINT_PERSON, {
        headers: await FHIRHEADERS(),
        method: 'POST',
        body: JSON.stringify({ org: "org1", ...user }),
      });

      if (response.status !== 200) {
       // throw new Error('Login failed');
       const errorData = await response.json();
       throw new Error(errorData.message || response.statusText);
      }

      const data = await response.json();
      console.log("We are logged in and setting local storage!!!", data);
      localStorage.setItem('mieFhiRToken', data.accessToken);
      localStorage.setItem('mieDisplayName', data.username);
      localStorage.setItem('userType', data.userType);
      console.log("We are logged in and going to set local storage. Here is the raw response from contract: ", data);
      //localStorage.setItem('userSession', JSON.stringify(data));
      this.setUserType(data.userType);

      // Return the user data to be used by the calling component
      return data;
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || err, {
        autoClose: 30000, // 30 seconds
      });
      throw err;
    }
  }

  async createNewUser(user) {
    try {
      console.log("MiEFhirService, user: " + user);
      const response = await fetch(FHIR_API_ENDPOINT_PERSON, {
        headers: await FHIRHEADERS(),
        method: 'POST',
        body: JSON.stringify(user),
      });
      console.log(response.status)
      console.log(response)
      // if (response.status !== 201) {
      
      //       console.log("error0");
       
      // }else{
      //       console.log("error1");
      //       const errorData = await response.json();
      //       throw new Error(errorData.message || response.statusText);
      // }

      const data = await response.json();
      console.log(data)
      return data;
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || err, {
        autoClose: 30000, // 30 seconds
      });
      throw err;
    }
  }

  setUserType(data) {
    this.userType = data.userType || "TRD";
    return this.userType;
  }

  currentUser() {
    const currentUser = JSON.parse(localStorage.getItem('userSession')) || {};
    if (currentUser && currentUser.userType) {
      this.setUserType(currentUser);
    } else {
      // Set a default user type if none is found
      this.userType = "TRD";
    }
    return currentUser;
  }

  isUserLogin() {
    const currentUser = this.currentUser();
    return !!currentUser.accessToken;
  }
}
